import { useVerifyMobileToken } from 'api/account';
import URLS from 'constants/urls';
import useUser from 'hooks/useUser';
import pages from 'pages';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import guessEnvironment from 'shared/utils/guessEnvironment';

export function MagicLinkRelay() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { preauthenticatedLogin } = useUser();

  const qaEnvironment = guessEnvironment() === 'qa';
  const billingUrl = qaEnvironment ? URLS.LAUNCH_SSO : URLS.EVERBRIGHT_ONLINE_ACCOUNT;

  const { mutateAsync: verifyMobileToken } = useVerifyMobileToken({
    onSuccess: ({ data: { user } }) => {
      // if the signed token successfully authenticates in the backend, log the user in for FE
      preauthenticatedLogin(user);
      // then redirect to the launch login page now that there's an active user session
      window.location.href = billingUrl;
    },
    onError: () => {
      navigate(`/${pages.LOGIN}`);
    },
  });

  const mobileSSOToken = searchParams.has('sso') ? searchParams.get('sso') : null;

  // if an SSO token is provided, query the backend to verify (and behave as if user is logged in if successful)
  useEffect(() => {
    if (!mobileSSOToken) return;
    const asyncEffect = async () => {
      await verifyMobileToken({ token: mobileSSOToken || '' });
    };
    asyncEffect();
  }, [mobileSSOToken, verifyMobileToken]);

  if (!mobileSSOToken) navigate(`/${pages.LOGIN}`);

  return null;
}

export default MagicLinkRelay;
